import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  locked$ = new BehaviorSubject(false);

  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.unlock();
    });
  }

  lock() {
    this.locked$.next(true);
    this.renderer.addClass(this.document.body, 'scroll-locked');
  }

  unlock() {
    this.locked$.next(false);
    this.renderer.removeClass(this.document.body, 'scroll-locked');
  }
}
